import axios from "axios";
import Config from "src/config";

const v1_actionWboObterTemplate = (clienteId, templateId) => {
    return axios({
        method: "get",
        url: `${Config.dev ? Config.url_dev : Config.urlBackend}/api/v1/${clienteId}/canais/wbo/templates/${templateId}`
    });
};

export default v1_actionWboObterTemplate;
